import { Link } from 'react-router-dom'
import { Button, Drawer } from 'antd'
import { MenuOutlined } from '@ant-design/icons'
import { useDialog } from 'src/shared/hooks'
import type SwiperCore from 'swiper'

import SearchV2 from './SearchV2'
import { QuoteButton } from './QuoteButton'
import { MenuMobile } from './MenuMobile'
import CartBtnV2 from './CartBtn/CartBtnV2'
import MenuV2 from './MenuV2'
import { UserPopoverV2 } from './UserPopover/UserPopoverV2'

import { DrawerHeaderStyled, MenuIconStyled } from './CartBtn/styles'
import { NavbarScrolledStyled } from './styles'

interface IProps {
  swiperInstance?: SwiperCore
}
const IndexV2 = (props: IProps) => {
  const modalReq = useDialog()
  const { open, handleClose, handleOpen } = useDialog()

  const NavbarComponent = NavbarScrolledStyled
  const MenuStyled = MenuIconStyled

  return (
    <NavbarComponent>
      <MenuStyled>
        <MenuOutlined onClick={handleOpen} />
      </MenuStyled>
      <Link className="logo-desktop" to="/">
        <img src={'/logos/logo.svg'} height="40" alt="Equip" />
      </Link>
      <Link className="logo-mobile" to="/">
        <img src={'/logos/logoresponsive.svg'} height="40" alt="Equip" />
      </Link>
      <MenuV2 modalReq={modalReq} swiperInstance={props.swiperInstance} />
      <SearchV2 />
      <div className="grid">
        <CartBtnV2 modalReq={modalReq} />
        <UserPopoverV2 />
        <QuoteButton modalReq={modalReq} handleClose={handleClose} />
      </div>

      <Drawer
        title={
          <DrawerHeaderStyled>
            <Link className="logo-desktop" to="/">
              <img className="logo" src="/logos/logo.svg" alt="Logo de Equip" />
            </Link>
            <Button onClick={handleClose}>Cerrar</Button>
          </DrawerHeaderStyled>
        }
        placement="left"
        closable={false}
        onClose={handleClose}
        open={open}
        key="left"
      >
        <MenuMobile modalReq={modalReq} handleClose={handleClose} />
      </Drawer>
    </NavbarComponent>
  )
}

export default IndexV2
